document.addEventListener('DOMContentLoaded', function() {
    // Function to handle scroll events
    function handleScroll() {
      // Calculate scroll position as percentage
      const scrollHeight = document.documentElement.scrollHeight - window.innerHeight;
      const scrollPosition = window.scrollY;
      const scrollPercentage = (scrollPosition / scrollHeight) * 100;
      
      // Add or remove class based on scroll position
      if (scrollPercentage >= 95) {
        document.body.classList.add('scrolled-to-footer');
      } else {
        document.body.classList.remove('scrolled-to-footer');
      }
    }
    
    // Add scroll event listener with throttling to improve performance
    let ticking = false;
    window.addEventListener('scroll', function() {
      if (!ticking) {
        window.requestAnimationFrame(function() {
          handleScroll();
          ticking = false;
        });
        ticking = true;
      }
    });
    
    // Initial check on page load
    handleScroll();

    const pageBody = document.querySelector('body');
    const url = window.location.pathname; // Gets "/en/projects"
    const slug = url.split('/').filter(Boolean).pop(); 
    const pageClass = "page-"+slug;
    pageBody.classList.add(pageClass);



setTimeout(function(){
  const radioButton = document.querySelector('.template-product .rbu-qb-tier-title input[type="radio"]');
      if (radioButton && !radioButton.checked) {
        radioButton.checked = true;
      }
}, 1000)
  });